module.exports = __webpack_public_path__ + "media/audios/kid/lesson_7/audio46-d7a1f91a2015e7951f0480d3509fcb5d.m4a";